var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrows = function SvgArrows(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.767 5.71.034.022a.57.57 0 0 0 .667-.116L9.483 1.37a.578.578 0 0 0-.838-.793L5.04 4.387 1.384.592a.577.577 0 0 0-.831.8L4.608 5.6l.028.02.016.018c.034.033.076.05.115.073Z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
};

export default SvgArrows;